export const en = {
  nav: {
    home: 'Home',
    gallery: 'Gallery',
    book: 'Book',
    memories: 'Memories',
    reviews: 'Reviews',
    contact: 'Contact',
    admin: 'Admin',
    login: 'Login',
    signin: 'Sign In',
    signup: 'Sign Up',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    account: 'Account',
    myAccount: 'My Account',
    logout: 'Logout',
    signOut: 'Sign Out',
    menu: 'Menu',
    retreat: 'Mountain Retreat',
  },
  home: {
    stats: {
      altitude: 'Altitude',
      guestRating: 'Guest Rating',
      happyGuests: 'Happy Guests',
      daysOpen: 'Days Open',
    },
    amenities: {
      label: 'Amenities',
      title: 'Mountain<br /><em>Luxuries</em>',
      subtitle: 'Every detail has been thoughtfully crafted to merge refined comfort with the raw beauty of the Carpathian highlands.',
      list: [
        {
          title: 'Mountain Views',
          desc: 'Panoramic vistas of the Carpathian peaks stretch endlessly from every window and terrace.',
          detail: 'Wake to golden sunrises painting the ridgeline, and end each day watching the alpenglow fade into starlight.',
        },
        {
          title: 'Heated Pool',
          desc: 'Warm waters beneath open skies — bathe under the stars in any season of the year.',
          detail: 'A year-round heated infinity pool set against the mountain panorama, with underwater lighting for twilight swims.',
        },
        {
          title: 'Fireplace',
          desc: 'Crackling flames and warm amber light create the perfect setting for unforgettable evenings.',
          detail: 'A grand stone hearth anchors the living space, with seasoned hardwood stacked and ready for every evening.',
        },
        {
          title: 'Forest Trails',
          desc: 'Step outside into ancient woodland paths waiting to be explored at dawn or dusk.',
          detail: 'Miles of marked trails through old-growth beech and spruce forests, from gentle meadow walks to summit scrambles.',
        },
        {
          title: 'Local Cuisine',
          desc: 'Traditional Romanian dishes prepared with fresh ingredients sourced from the surrounding valleys.',
          detail: 'From sarmale to mămăligă cu brânză, every meal celebrates Transylvanian heritage with locally foraged ingredients.',
        },
        {
          title: 'Stargazing',
          desc: 'Zero light pollution reveals a breathtaking canopy of stars visible from the observation deck.',
          detail: 'A dedicated observation platform with reclining chairs and a telescope for exploring the Milky Way in stunning clarity.',
        }
      ]
    },
    experiences: {
      list: [
        'Wildlife encounters in pristine forests',
        'Mushroom foraging with local guides',
        'Skiing at nearby slopes in winter',
        'Golden sunrise meditation sessions',
        'Traditional cooking workshops',
        'Mountain stream fishing excursions'
      ]
    },
    hero: {
      tagline: 'A Carpathian Sanctuary',
      titleMain: 'Cabana',
      titleAccent: 'PIATRA BURU',
      subtitle: 'Nestled at 1,200 m in ancient forests where<br /> time surrenders to the rhythm of nature',
      chipLocation: 'Romania',
      chipType: 'Mountain Retreat',
      chipEst: 'Est. 1947',
      cta: 'Book Your Stay',
      viewGallery: 'View Gallery',
      rating: '4.9 from 120+ guests',
      scroll: 'Scroll to discover'
    },
    story: {
      label: 'Our Story',
      title: 'Where Mountains<br /><em>Meet Magic</em>',
      text1: 'Perched at 1,200 meters in the Romanian Carpathians, Cabana Piatra Buru has welcomed travelers since generations past. Built from ancient spruce and local stone, every beam tells a story of mountain craftsmanship passed down through centuries.',
      text2: 'Whether you seek adventure on rugged trails or serenity by a crackling fire, this is the place where your story continues. The forest breathes, the mountains watch, and time moves at a different pace.'
    },
    footerCTA: {
      label: 'Your Escape Awaits',
      title: 'Ready to<br /><em>Find Peace?</em>',
      subtitle: 'Join us above the clouds and discover the unforgettable Transylvanian landscape.',
      button: 'Find Available Dates'
    },
    experience: {
      label: 'The Signature Experience',
      title1: 'Embrace',
      title2: 'the Wild',
      desc: 'Beyond our cabin doors, a world of natural wonder awaits. We partner with local guides and conservationists to let you experience the Carpathians in their purest form.'
    },
    glance: {
      label: 'At a Glance',
      title1: 'The Cabin',
      title2: 'in Detail',
      propertyType: {
        label: 'Property Type',
        value: 'Entire Cabin (Private)'
      },
      capacity: {
        label: 'Capacity',
        value: 'Up to 8 Guests'
      },
      location: {
        label: 'Location',
        value: 'Apuseni Mountains, RO'
      },
      checkInOut: {
        label: 'Check-in / Check-out',
        value: '3:00 PM / 11:00 AM'
      },
      availability: {
        label: 'Availability',
        value: 'Open Year-Round'
      },
      cancellation: {
        label: 'Cancellation',
        value: 'Free 14 days prior'
      },
      highlights: {
        title: 'Cabin Highlights',
        items: [
          'Heated infinity pool & sauna',
          'Fully equipped gourmet kitchen',
          'Fireplace with seasoned firewood',
          'High-speed Wi-Fi throughout',
          'Private parking on premises',
          'Fresh local welcome basket',
          'Board games & library nook',
          'Observation deck & telescope'
        ]
      },
      ctaLabel: 'Starting from',
      ctaPrice: '€120',
      ctaPerNight: '/night',
      ctaButton: 'Check Dates'
    },
    cta: {
      badge: 'Direct Booking',
      title1: 'Your Next',
      title2: 'Adventure',
      desc: 'Reserve a date today and ensure your retreat in the midst of the cloud-covered mountains. Rates include all amenities.',
      button: 'Find Availability',
      reassurance: 'Secure online payment and instant confirmation'
    },
    attractions: {
      label: 'Nearby Attractions',
      title1: 'Discover What’s',
      title2: 'Around Buru',
      subtitle: 'From dramatic gorges and iconic viewpoints to salt mines and heritage villages — these are some of our favorite day trips, all within easy reach.',
      tags: {
        nature: 'Nature',
        hike: 'Hike',
        waterfall: 'Waterfall',
        viewpoint: 'Viewpoint',
        peak: 'Peak',
        unique: 'Unique',
        village: 'Village',
        history: 'History',
        culture: 'Culture',
        museum: 'Museum',
      },
      diff: {
        easy: 'Easy',
        moderate: 'Moderate',
        hard: 'Hard',
      },
      strip: {
        distance: 'Distance from cabin',
        time: 'Visit duration',
        tip: 'Local tip included',
      },
      explore: 'Details',
      modal: {
        fromCabin: 'from cabin',
        distance: 'Distance',
        walkTime: 'Visit time',
        halfDay: '~Half day',
        bestSeason: 'Best season',
        springSummer: 'Apr – Oct',
        bookStay: 'Book a Stay & Explore',
        localTip: '💡 Local tip',
      },
      tips: {
        tip1: 'Go early morning — the valley mist creates dream-like scenery.',
        tip2: 'Bring water and good boots. The full trail takes about 4 hours.',
        tip3: 'Perfect for a picnic. Bring a blanket and snacks!',
        tip4: 'Hike at sunrise for stunning panoramas above the clouds.',
        tip5: 'Forest roads are driveable halfway up — saves a lot of time.',
        tip6: 'Buy your ticket online — long queues at the entrance on weekends.',
        tip7: 'Walk through the village on foot — every corner has a story.',
        tip8: 'The ridge walk takes 30 min and offers unique views.',
        tip9: 'Entry is free. Please respect the silence of the place.',
        tip10: 'The guided tour (30 min) is very worthwhile — ask at the entrance.',
      },
      items: {
        cheileBorzesti: {
          name: 'Cheile Borzești',
          desc: 'A quiet gorge near Buru, perfect for a short nature walk and fresh mountain air.',
        },
        cheileTurzii: {
          name: 'Cheile Turzii',
          desc: 'One of Transylvania’s most spectacular canyons — hiking trails, cliffs, and big views.',
        },
        cascadaCiucas: {
          name: 'Cascada Ciucaș',
          desc: 'A scenic waterfall hideaway — great for an easy excursion and a relaxing picnic.',
        },
        piatraSecuiului: {
          name: 'Piatra Secuiului',
          desc: 'The iconic rock above Rimetea — climb for sunrise/sunset panoramas you won’t forget.',
        },
        munteleMare: {
          name: 'Muntele Mare',
          desc: 'A classic Apuseni mountain day — forest roads, alpine meadows, and wide horizons.',
        },
        salinaTurda: {
          name: 'Salina Turda',
          desc: 'A world-famous salt mine turned underground wonderland — surreal, fun, and family-friendly.',
        },
        rimetea: {
          name: 'Rimetea Village',
          desc: 'A beautifully preserved village with white houses and Hungarian heritage, at the foot of Piatra Secuiului.',
        },
        cetateaColtesti: {
          name: 'Cetatea Colțești',
          desc: 'Ruins of a medieval fortress with a stunning ridge walk and amazing photo spots.',
        },
        woodenChurchBuru: {
          name: 'Wooden Church of Buru',
          desc: 'A local landmark with traditional craftsmanship and a calm, authentic atmosphere.',
        },
        ethnographicMuseumRimetea: {
          name: 'Ethnographic Museum in Rimetea',
          desc: 'A small museum that brings local traditions to life — crafts, costumes, and rural history.',
        },
      },
    }
  },
  footer: {
    brand: {
      tagline: 'Where the mountains welcome you home',
      desc: 'Nestled at 1,200m in the Carpathians, our chalet offers an authentic mountain retreat surrounded by ancient forests and breathtaking peaks.'
    },
    navigate: {
      title: 'Navigate',
      home: 'Home',
      gallery: 'Gallery',
      book: 'Book a Stay',
      reviews: 'Reviews',
      contact: 'Contact',
    },
    experience: {
      title: 'Experience',
      views: 'Mountain Views',
      trails: 'Forest Trails',
      cuisine: 'Local Cuisine',
      stargazing: 'Stargazing',
    },
    guest: {
      title: 'Guest',
      signIn: 'Sign In',
      register: 'Register',
      account: 'My Account',
      writeReview: 'Write a Review',
    },
    bottom: {
      rights: '© 2026 Cabana Piatra Buru. All rights reserved.',
      madeWith: 'Made with'
    }
  },
  contact: {
    hero: {
      tagline: "We'd Love to Hear From You",
      title1: 'Get in',
      title2: 'Touch',
      sub: 'Reach out anytime — our doors and phone lines are always open'
    },
    methods: {
      title1: 'Choose Your',
      title2: 'Way',
      subtitle: "Pick whichever feels most convenient — we're equally happy on all channels",
      list: [
        {
          label: 'Phone Call',
          description: 'Available daily from 8:00 AM to 10:00 PM (Romania time)',
          action: 'Call Now'
        },
        {
          label: 'WhatsApp',
          description: 'Quick replies — usually within 30 minutes during daytime',
          action: 'Open Chat'
        },
        {
          label: 'Email',
          description: 'We respond within 24 hours — perfect for detailed inquiries',
          action: 'Send Email'
        }
      ]
    },
    faq: {
      tagline: 'Got Questions?',
      title1: 'Common',
      title2: 'Inquiries',
      sub: 'Find quick answers to the most frequent questions about your stay.',
      list: [
        {
          q: 'What is the best time to visit?',
          a: 'Each season has its own magic. Summer is perfect for hiking and swimming, autumn for golden foliage, winter for snow and coziness, and spring for wildflower meadows.'
        },
        {
          q: 'How do I get to the cabin?',
          a: "We're accessible by car via DN7A. The last 2km is on a forest road. We provide detailed directions and GPS coordinates upon booking. Airport pickup from Sibiu can be arranged."
        },
        {
          q: 'Is there Wi-Fi available?',
          a: 'Yes, we have reliable Wi-Fi throughout the cabin. However, we encourage guests to disconnect and enjoy the mountain air!'
        },
        {
          q: 'Can I bring my pet?',
          a: 'We love furry guests! Dogs are welcome with prior notice. We have a fenced yard area and nearby trails perfect for walks.'
        },
        {
          q: 'What is the cancellation policy?',
          a: 'Free cancellation up to 7 days before check-in. Cancellations within 7 days receive a 50% refund. We understand plans change — just reach out!'
        }
      ]
    },
    location: {
      tagline: 'Getting Here',
      title1: 'Find Your',
      title2: 'Way',
      address: 'DN7A km 45, Apuseni Mountains, Romania',
      desc: 'Nestled deep within the forest, our exact coordinates secure your slice of peace. Follow the pines to serenity.'
    },
    info: {
      responseTime: {
        label: 'Response Time',
        value: 'Within 30 min'
      },
      location: {
        label: 'Location',
        value: 'Carpathian Mountains, Romania'
      },
      availability: {
        label: 'Availability',
        value: 'Open 365 days a year'
      }
    },
    mapDetails: {
      address: {
        label: 'Address',
        value: 'Cabana Piatra Buru, Munții Șureanu, Jud. Alba, Romania'
      },
      coords: {
        label: 'Coordinates',
        value: '45.6123° N, 23.4567° E'
      },
      note: {
        label: 'Note',
        value: 'We send detailed directions with GPS waypoints after booking'
      },
      alt: '1,200m altitude'
    },
    bottom: {
      title: "Can't wait to welcome you",
      desc: "Whether it's your first visit or your tenth, the mountains are always calling",
      whatsapp: 'WhatsApp Us',
      call: 'Call Us Now'
    }
  },
  memories: {
    label: 'A Visual Journal',
    heroTitleStart: 'Our',
    heroTitleAccent: 'Memories',
    title: 'The Scrapbook',
    subtitle: 'Share your favorite moments from your stay with fellow guests.',
    stats: {
      photos: 'Photos',
      contributors: 'Contributors',
      likes: 'Likes'
    },
    addJournal: 'Add to the Journal',
    uploadPrompt: 'Upload your best moments from Cabana Piatra Buru',
    guestNotice: 'You’re browsing as a guest.',
    signInUpload: 'Sign in',
    toUpload: 'to upload.',
    caption: 'Caption',
    captionPlaceholder: 'e.g. Sunrise coffee on the terrace',
    photos: 'Photos',
    dropPhotos: 'Click or drag photos here',
    supportFiles: 'Supports JPG, PNG, WebP',
    maxImages: 'Maximum 10 images, up to 6MB per file.',
    publishing: 'Uploading...',
    publishButton: 'Publish Memories',
    latest: 'Latest Contributions',
    noUploads: 'No uploads yet. Be the first to share a memory.',
    like: 'Like',
    liked: 'Liked',
    by: 'by'
  },
  book: {
    heroLabel: 'Reservations',
    heroTitleMain: 'Book Your',
    heroTitleAccent: 'Mountain Retreat',
    heroSub: 'Select your dates and escape to the Carpathians',
    days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    available: 'Available',
    booked: 'Booked',
    selected: 'Selected',
    signInReq: 'Sign In Required',
    signInDesc: 'Please sign in to your account to make a reservation at Cabana Piatra Buru.',
    signInBtn: 'Sign In',
    noAccount: 'Don\'t have an account?',
    createOne: 'Create one',
    yourReservation: 'Your Reservation',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    selectDate: 'Select date',
    guests: 'Guests',
    specialNotes: 'Special Notes',
    notesPlaceholder: 'Dietary requirements, special occasions, etc.',
    summary: 'Summary',
    nights: 'nights',
    total: 'Total',
    confirmBtn: 'Request Reservation',
    confirming: 'Submitting...',
    successMsg: 'Your booking request has been submitted! The admin will review and confirm your reservation shortly.',
    errorRange: 'Selected range overlaps with an existing booking.',
    errorDates: 'Please select check-in and check-out dates.',
    errorGeneric: 'Something went wrong.'
  },
  account: {
    heroTag: 'My Account',
    welcomeBack: 'Welcome back',
    traveler: 'Traveler',
    heroDesc: 'Manage your mountain retreats and track your journey with us',
    statsTotalStays: 'Total Stays',
    statsNights: 'Nights Spent',
    statsUpcoming: 'Upcoming',
    statsGuests: 'Guests Hosted',
    statsFavMonth: 'Favourite Month',
    loyaltyTag: '🌿 Loyalty Program',
    loyaltyDiscount: 'DISCOUNT',
    loyaltyMoreStays: 'more stays to',
    loyaltyMoreStay: 'more stay to',
    loyaltyStays: 'stays',
    profileTag: '👤 Profile',
    profileSignOut: 'Sign Out',
    profileEmail: 'Email',
    profilePhone: 'Phone Number',
    profileName: 'Full Name',
    profileJoined: 'Member Since',
    profileSave: 'Save Changes',
    profileSaving: 'Saving...',
    tabsUpcoming: 'Upcoming & Active',
    tabsPast: 'Past Stays',
    tabsCancelled: 'Cancelled',
    bookingId: 'Booking ID',
    bookingCheckIn: 'Check-in',
    bookingCheckOut: 'Check-out',
    bookingGuests: 'Guests',
    bookingTotal: 'Total',
    bookingCancelPrompt: 'Cancel this booking?',
    bookingCancelBtn: 'Cancel Booking',
    bookingCancelledBtn: 'Cancelled',
    bookingNoStays: 'No stays found in this category.',
    statusUpcoming: 'Upcoming',
    statusActive: 'Active',
    statusCompleted: 'Completed',
    statusCancelled: 'Cancelled',
    profileSuccess: 'Profile updated successfully!',
    months: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  },
  gallery: {
    hero: {
      label: 'Photo Gallery',
      titleStart: 'Captured',
      titleAccent: 'Moments',
      subtitle: 'Every frame tells the story of Cabana Piatra Buru — from golden sunrises over the Carpathian peaks to cozy evenings by the fire.',
      statPhotos: 'Photos',
      statCategories: 'Categories',
      statQuality: 'Quality',
      scroll: 'Explore',
      feat1Title: 'Mountain Views',
      feat1Desc: 'Panoramic Carpathian scenery at every turn',
      feat2Title: 'Cozy Interiors',
      feat2Desc: 'Warm fireplace rooms with rustic charm',
      feat3Title: 'Outdoor Activities',
      feat3Desc: 'Hiking, cycling & nature trails nearby',
      feat4Title: 'Fresh Mountain Air',
      feat4Desc: 'Surrounded by ancient forests & clean air'
    },
    filters: {
      all: 'All Photos',
      exterior: 'Exterior',
      interior: 'Interior',
      nature: 'Nature',
      activities: 'Activities'
    },
    showing: 'Showing',
    photos: 'photos',
    emptyTitle: 'No photos found',
    emptyText: 'Try selecting a different category.',
    cta: {
      titleStart: 'Ready to',
      titleAccent: 'Experience This?',
      text: 'Book your mountain escape and create your own unforgettable moments at Cabana Piatra Buru.',
      button: 'Book Your Stay'
    }
  },
  admin: {
    panelTitle: 'Admin Panel',
    panelSub: 'Cabana Piatra Buru',
    hello: 'Hello',
    overviewTitle: 'Dashboard Overview',
    usersTitle: 'All Users',
    bookingsTitle: 'All Bookings',
    reviewsTitle: 'All Reviews',
    memoriesTitle: 'User Memories',
    messagesTitle: 'Contact Messages',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    joined: 'Joined',
    actions: 'Actions',
    guest: 'Guest',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Guests',
    status: 'Status',
    tabDashboard: 'Dashboard',
    tabUsers: 'Users',
    tabBookings: 'Bookings',
    tabReviews: 'Reviews',
    tabMemories: 'Memories',
    tabMessages: 'Messages',
  }
};
